<template>
  <div>HOME</div>
</template>
<script>
export default {
  name: 'Home',
};
</script>
